import { render, staticRenderFns } from "./Defects.vue?vue&type=template&id=47991ae4&"
import script from "./Defects.vue?vue&type=script&lang=js&"
export * from "./Defects.vue?vue&type=script&lang=js&"
import style0 from "./Defects.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports